import { render, staticRenderFns } from "./edit-type.vue?vue&type=template&id=39b6b341&scoped=true&"
import script from "./edit-type.vue?vue&type=script&lang=js&"
export * from "./edit-type.vue?vue&type=script&lang=js&"
import style0 from "./edit-type.vue?vue&type=style&index=0&id=39b6b341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6b341",
  null
  
)

export default component.exports